import { Component } from '@angular/core';

/**
 * Thin shell hosting `<lib-access-request-management>` from
 * `@nucleus/access-request-ui`. The page logic lives in the lib; this
 * component exists so the route in administration-routing.module.ts keeps
 * its existing reference.
 *
 * DI tokens (NUCLEUS_ACCESS_REQUEST_SERVICE, NUCLEUS_ACCESS_REQUEST_DATA,
 * NUCLEUS_ACCESS_REQUEST_AUDIT_TRAIL_OPENER, NUCLEUS_ACCESS_REQUEST_REPORT_FILENAME)
 * are registered at the AdministrationModule level via
 * `NUCLEUS_ACCESS_REQUEST_UI_PROVIDERS`. NUCLEUS_ACCESS_REQUEST_DATA is required
 * here (not just in the dialog context) because the lib component injects it
 * non-optionally; the routed page has no parent injector to fall back on.
 */
@Component({
  selector: 'app-access-request-management',
  standalone: false,
  template: '<lib-access-request-management></lib-access-request-management>',
  styles: [':host { display: flex; flex-direction: column; height: 100%; }'],
})
export class AccessRequestManagementComponent {}
